import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import BootstrapTooltip from "../../partials/content/BootstrapTooltip";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import parse from "html-react-parser";
import { Table } from "react-bootstrap";
import ResponsiveEllipsis from "../../partials/content/ResponsiveEllipsis";
import { formatDate } from "../../utils/utils";
import NumberFormat from "react-number-format";
import { deleteSelected } from "../../services/commons";
import Swal from "sweetalert2";
import { Dropdown } from "primereact/dropdown";
import { DateTime } from "luxon";
import { Typography } from "@material-ui/core";

const CustomDataTable = ({
  dataDetailTitle = "",
  dataDetailName = "",
  dataDetailColumns = [],
  data = [],
  count = 0,
  buttons = [],
  columns = [
    {
      header: "",
      field: "",
      body: (rowData) => null,
      sortable: false,
      filter: false,
      hidden: false,
      footer: false,
      selectionMode: "",
    },
  ],
  showTopToolbar = true,
  selectionMode = "",
  onRefreshData = function() {},
  onSelectedData = function() {},
  currentDateTime = DateTime.now(),
  tableName = "",
  lazy = false,
  onHitRecord = function() {},
}) => {
  const [expandedRows, setExpandedRows] = useState(null);
  const [filters, setFilters] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const dt = useRef(null);
  const [selectedData, setSelectedData] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 5,
    page: 1,
    sortField: "",
    sortOrder: 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalRows, setTotalRows] = useState(10);
  const [loading, setLoading] = useState(false);
  const [sorted, setSorted] = useState(false);
  const [dataSorted, setDataSorted] = useState(data);
  let loadLazyTimeout = null;
  const rowOption = [
    { label: 5 },
    { label: 10 },
    { label: 15 },
    { label: 20 },
    { label: 25 },
  ];

  useEffect(() => {
    initFilters();
    loadLazyData();
  }, [expandedRows, lazyParams, totalRows]);

  const clearFilter = () => {
    initFilters();
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  const initFilters = () => {
    const filtersTmp = { ...filters };
    filtersTmp["global"] = { value: null, matchMode: FilterMatchMode.CONTAINS };
    if (typeof columns !== "undefined") {
      columns.map((column, index) => {
        if (column.filter === true) {
          filtersTmp[`${column.field}`] = {
            operator: FilterOperator.AND,
            constraints: [
              { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            ],
          };
        }
      });
    }
    setFilters(filtersTmp);
    setGlobalFilter("");
  };

  const expandAll = () => {
    setExpandedRows(data);
  };

  const collapseAll = () => {
    setExpandedRows(null);
  };

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));
  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({
      selectionOnly,
      fileName: `invifo-${currentDateTime}.pdf`,
    });
  };
  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, data);
        doc.save(`invifo-${currentDateTime}.pdf`);
      });
    });
  };
  const handleDeleteSelected = (quotationID = 0) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: `Are you sure want to mass delete this selected data ?`,
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteSelected(selectedData, tableName).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            onRefreshData();
            setSelectedData([]);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, `invifo-${currentDateTime}`);
    });
  };
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(
        data,
        fileName +
          "_export_" +
          DateTime.now().toFormat("yyyy-MM-dd, hh:mm a ZZZZZ (ZZZZ)") +
          EXCEL_EXTENSION
      );
    });
  };
  const header = (
    <div className="table-header">
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6">
          <span className="text-nowrap">
            {buttons.length > 0 ? (
              <React.Fragment>
                {buttons.map((button, index) => (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-${
                      button.color ? button.color : "primary"
                    } btn-sm btn-pill btn-bold mx-1 my-1`}
                    variant="primary"
                    onClick={button.onClick}
                  >
                    {button.icon ? <i className={button.icon}></i> : null}
                    {button.name}
                  </button>
                ))}
              </React.Fragment>
            ) : null}
          </span>
          <span className="text-nowrap">
            <BootstrapTooltip title="Export To PDF">
              <button
                type="button"
                onClick={exportPdf}
                className="btn btn-icon btn-label-danger btn-circle btn-sm mx-1 my-1"
              >
                <i className="fas fa-file-pdf"></i>
              </button>
            </BootstrapTooltip>
            <BootstrapTooltip title="Export To Excel">
              <button
                type="button"
                onClick={exportExcel}
                className="btn btn-icon btn-label-success btn-circle btn-sm mx-1 my-1"
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </BootstrapTooltip>
            <BootstrapTooltip title="Export To CSV">
              <button
                type="button"
                onClick={() => exportCSV(false)}
                className="btn btn-icon btn-label-info btn-circle btn-sm mx-1 my-1"
              >
                <i className="fas fa-file-csv"></i>
              </button>
            </BootstrapTooltip>
            {dataDetailColumns.length > 0 ? (
              <React.Fragment>
                <BootstrapTooltip title="Expand All">
                  <button
                    type="button"
                    onClick={expandAll}
                    className="btn btn-icon btn-circle btn-label-brand btn-sm mx-1 my-1"
                  >
                    <i className="far fa-arrow-alt-circle-down"></i>
                  </button>
                </BootstrapTooltip>
                <BootstrapTooltip title="Collapse All">
                  <button
                    type="button"
                    onClick={collapseAll}
                    className="btn btn-icon btn-circle btn-label-brand btn-sm mx-1 my-1"
                  >
                    <i className="far fa-arrow-alt-circle-up"></i>
                  </button>
                </BootstrapTooltip>
                {selectedData.length > 0 ? (
                  <BootstrapTooltip title="Mass Delete Selected Data">
                    <button
                      type="button"
                      onClick={(event) => handleDeleteSelected(selectedData)}
                      className="btn btn-icon btn-label-danger btn-circle btn-sm mx-1 my-1"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </BootstrapTooltip>
                ) : null}
              </React.Fragment>
            ) : null}
          </span>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <span className="p-input-icon-left float-md-right mx-1 my-1">
            <i className="pi pi-search" />
            <InputText
              type="search"
              value={globalFilter}
              onChange={onGlobalFilterChange}
              placeholder="Global Search"
            />
          </span>
          <BootstrapTooltip title="Refresh Filter Criteria">
            <button
              type="button"
              className="btn btn-label-brand btn-sm btn-pill btn-bold float-md-right mx-1 my-1"
              onClick={() => {
                setGlobalFilter("");
                dt.current.reset();
                clearFilter();
              }}
            >
              <i className="pi pi-filter-slash"></i>
              Clear
            </button>
          </BootstrapTooltip>
        </div>
      </div>
    </div>
  );

  // Setting Lazy
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    //imitate delay of a backend call
    loadLazyTimeout = setTimeout(() => {
      onHitRecord(
        lazyParams.first,
        lazyParams.rows,
        lazyParams.sortField,
        lazyParams.sortOrder
      );
      setTotalRecords(count);
      setLoading(false);
    }, Math.random() * 1000 + 250);
  };
  const onPage = (event) => {
    setSorted(false);
    setDataSorted();
    setLazyParams(event);
  };

  const onSort = (event) => {
    setSorted(true);
    setDataSorted();
    setLazyParams({
      first: lazyParams.first,
      rows: lazyParams.rows,
      sortField: event.sortField,
      sortOrder: event.sortOrder,
    });
    // let sortField = event.sortField;
    // if (event.sortOrder === 1) {
    //   const strAscending = [...data].sort((a, b) =>
    //     sortField > sortField ? 1 : -1
    //   );
    //   console.log("sortField", sortField);
    //   setDataSorted(strAscending);
    // } else if (event.sortOrder === -1) {
    //   const strDescending = [...data].sort((a, b) =>
    //     sortField > sortField ? -1 : 1
    //   );
    //   setDataSorted(strDescending);
    // }
  };

  const onFilter = (event) => {
    event["first"] = 0;
    setLazyParams(event);
  };

  const onTotalRowChange = (event) => {
    setSorted(false);
    setDataSorted();
    const value = event.value;
    setTotalRows(value.label);
  };
  return (
    <React.Fragment>
      <div className="card datatable-responsive datatable-filter">
        <DataTable
          value={data}
          lazy={lazy}
          filterDisplay="menu"
          responsiveLayout="scroll"
          paginator
          first={lazyParams.first}
          rows={totalRows}
          totalRecords={totalRecords}
          onPage={lazy ? onPage : null}
          onSort={lazy ? onSort : null}
          sortField={lazy ? lazyParams.sortField : null}
          sortOrder={lazy ? lazyParams.sortOrder : null}
          onFilter={lazy ? onFilter : null}
          loading={lazy ? loading : null}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={(rowData) => (
            <React.Fragment>
              {dataDetailName !== "" ? (
                <React.Fragment>
                  <Typography className="kt-font-bolder mt-2 mb-3">
                    {dataDetailTitle}
                  </Typography>
                  <DataTable
                    value={rowData[dataDetailName]}
                    filterDisplay="menu"
                    responsiveLayout="scroll"
                    stripedRows
                    size="small"
                    emptyMessage="You have no data at this time"
                  >
                    {dataDetailColumns.map((column, index) => (
                      <Column
                        headerStyle={{ display: "" }}
                        key={index}
                        header={column.header}
                        field={column.field}
                        body={column.body}
                        sortable={column.sortable}
                        filter={column.filter}
                        hidden={column.hidden}
                        footer={column.footer}
                      />
                    ))}
                  </DataTable>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="row justify-content-center mx-0">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <div className="table-responsive">
                        <Table borderless hover size="sm" className="mb-0">
                          <tbody>
                            {dataDetailColumns.map((column, index) => (
                              <React.Fragment key={index}>
                                <tr className="border-bottom-0">
                                  <td className="w-50 table-header-left pl-0 pr-3 py-1 text-right kt-font-bolder">
                                    {column.header}
                                  </td>
                                  <td className="w-50pl-0 pl-3 py-1">
                                    {column.type === "string" ? (
                                      <React.Fragment>
                                        <ResponsiveEllipsis
                                          text={rowData[`${column.field}`]}
                                          maxLine="1"
                                        />
                                      </React.Fragment>
                                    ) : column.type === "boolean" ? (
                                      <React.Fragment>
                                        <ResponsiveEllipsis
                                          text={`${rowData[`${column.field}`]}`}
                                          maxLine="1"
                                        />
                                      </React.Fragment>
                                    ) : column.type === "date" ? (
                                      <React.Fragment>
                                        {formatDate(rowData[`${column.field}`])}
                                      </React.Fragment>
                                    ) : column.type === "datetime" ? (
                                      <React.Fragment>
                                        {formatDate(
                                          rowData[`${column.field}`],
                                          true
                                        )}
                                      </React.Fragment>
                                    ) : column.type === "currency" ? (
                                      <React.Fragment>
                                        <NumberFormat
                                          value={rowData[`${column.field}`]}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                        />
                                      </React.Fragment>
                                    ) : column.type === "html" ? (
                                      <React.Fragment>
                                        {parse(rowData[`${column.field}`])}
                                      </React.Fragment>
                                    ) : null}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          header={showTopToolbar ? header : null}
          globalFilter={!lazy ? globalFilter : null}
          filters={!lazy ? filters : null}
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          selectionMode={selectionMode ? selectionMode : ""}
          selection={selectedData}
          onSelectionChange={(e) => {
            onSelectedData(e.value);
            setSelectedData(e.value);
          }}
          // onSelectionChange={(e) => onSelectedData(e.value)}
          rowsPerPageOptions={
            !lazy ? [5, 10, 25, 50, 100, 200, 500, 1000, 5000, 10000] : null
          }
          paginatorLeft={
            <React.Fragment>
              <BootstrapTooltip title="Refresh Data">
                <Button
                  type="button"
                  icon="pi pi-refresh"
                  className="p-button-text"
                  onClick={() => {
                    onRefreshData();
                  }}
                />
              </BootstrapTooltip>
              {lazy ? (
                <Dropdown
                  options={rowOption}
                  value={totalRows}
                  optionLabel="label"
                  filterBy="label"
                  placeholder={`Total Row : ${totalRows}`}
                  onChange={onTotalRowChange}
                />
              ) : null}
            </React.Fragment>
          }
          paginatorRight={
            <Button
              type="button"
              icon="pi pi-cloud"
              className="p-button-text"
            />
          }
          ref={dt}
          stripedRows
          size="small"
          //showGridlines
          //className="p-datatable-responsive"
          emptyMessage="You have no data at this time"
          //reorderableColumns
        >
          {dataDetailColumns.length > 0 ? (
            <Column expander style={{ width: "3em" }} />
          ) : null}
          {/* For Unexpanded Column */}
          {columns.map((column, index) => (
            <Column
              key={index}
              header={column.header}
              field={column.field}
              body={column.body}
              sortable={column.sortable}
              style={{
                //width: `${column.header === "ID" ? "80px" : null}`,
                whiteSpace: `${column.header === "Actions" ? "nowrap" : null}`,
              }}
              filter={column.filter}
              filterPlaceholder={`🔍 ${column.header}`}
              selectionMode={column.selectionMode}
              hidden={column.hidden}
              footer={column.footer}
            />
          ))}
          {/* For Expanded Colum */}
          {dataDetailColumns.map((column, index) => (
            <Column
              key={index}
              header={column.header}
              field={column.field}
              body={(rowData) =>
                column.type === "string" ? (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData[`${column.field}`]}
                      maxLine="1"
                    />
                  </React.Fragment>
                ) : column.type === "date" ? (
                  <React.Fragment>
                    {formatDate(rowData[`${column.field}`])}
                  </React.Fragment>
                ) : column.type === "currency" ? (
                  <React.Fragment>
                    <NumberFormat
                      value={rowData[`${column.field}`]}
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalScale={2}
                    />
                  </React.Fragment>
                ) : column.type === "html" ? (
                  <>{parse(rowData[`${column.field}`])}</>
                ) : null
              }
              hidden={true}
            />
          ))}
        </DataTable>
      </div>
    </React.Fragment>
  );
};

export default CustomDataTable;
